import classNames from 'classnames';
import React from 'react';
import Tooltip from 'rc-tooltip';
import { MdOutlineAreaChart } from 'react-icons/md';
import { AreaSearch } from '../models/AreaSearch';
type AreasProps = React.HTMLAttributes<HTMLDivElement> & {
  items: AreaSearch['areas'];
};

const Areas: React.FC<AreasProps> = ({ children, className, items, ...props }) => {
  if (items?.length === 0) {
    return null;
  }

  return (
    <span className={classNames('inline-flex gap-1 items-center text-xs', className)} {...props}>
      <span className="inline-flex gap-1 items-center">
        <MdOutlineAreaChart className="w-4" />
        <Tooltip
          placement="bottom"
          trigger={['click', 'hover']}
          overlayClassName="opacity-100"
          overlay={
            <div className="max-w-xs">
              {items.map((area: any, index: number) => (
                <span key={area.name} title={area.name}>
                  {area.name.split(', ')[0]}
                  {area.radius ? <> ({area.radius}km)</> : ''}
                  {index < items.length - 1 ? ', ' : ''}
                </span>
              ))}
            </div>
          }
        >
          <span className="line-clamp-2">
            {items.map((area: any, index: number) => (
              <span key={area.name} title={area.name}>
                {area.name.split(', ')[0]?.split(' - ')[0]}
                {area.radius ? <> ({area.radius}km)</> : ''}
                {index < items.length - 1 ? ', ' : ''}
              </span>
            ))}
          </span>
        </Tooltip>
      </span>
    </span>
  );
};

export default Areas;
